import { render, staticRenderFns } from "./DialogUser.vue?vue&type=template&id=67b35f14&scoped=true"
import script from "./DialogUser.vue?vue&type=script&lang=js"
export * from "./DialogUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b35f14",
  null
  
)

export default component.exports